"use client";

import Image from "next/image";
import Link from "next/link";

interface Partner {
  name: string;
  href: string;
  domain: string;
  logo: string;
}

export default function PartnerMarquee({ partners }: { partners: Partner[] }) {
  // For a small number of partners we show a centered responsive grid
  // so the block looks tidy and doesn't 'cheap out' the page when few logos
  return (
    <div className="w-full bg-secondary/70 py-6">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 items-center justify-items-center">
          {partners.map((partner, idx) => (
            <Link
              key={`${partner.name}-${idx}`}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-[180px] flex items-center justify-center rounded-sm border border-white/10 bg-primary/70 p-3 transition-all duration-200 hover:shadow-lg"
            >
              <div className="relative w-full h-12 md:h-16 p-2 flex items-center justify-center">
                {partner.logo ? (
                  <Image
                    src={partner.logo}
                    alt={partner.name}
                    fill
                    sizes="(min-width: 1024px) 160px, (min-width: 640px) 120px, 80px"
                    className="object-contain transition-transform duration-200 ease-out grayscale opacity-80 hover:grayscale-0 hover:opacity-100"
                  />
                ) : (
                  <div className="w-full h-full bg-primary/10" aria-hidden="true" />
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
